import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const HistoriqueevaluationService = {
  async insertOrUpdate(data) {
    try {
      const result = await axios.post(
        `${apiUrl}/EvaluationHistorique/insert_or_update`,
        data,
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getCurrentHistoryByCandidatAndEvaluateur(id_candidat, id_evaluateur,id_session) {
    try {
      const result = await axios.get(
        `${apiUrl}/EvaluationHistorique/get_current_history_by_candidat_and_evaluateur`,
        {
          params: {
            id_candidat,
            id_evaluateur,
            id_session
          },
        },
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getNumberOfEvaluatorsByCandidatAndSession(id_candidat) {
    try {
      const result = await axios.get(
        `${apiUrl}/EvaluationHistorique/get_number_of_evaluators_by_candidat_and_session`,
        {
          params: {
            id_candidat,
          },
        },
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
